{
  "network": {
    "unexpected": "An unexpected error occurred. Please try again.",
    "connectionFailed": "Connection failed. Please check your network.",
    "timeout": "Request timed out. Please try again."
  },
  "auth": {
    "invalidCredentials": "Invalid credentials. Please check your email and password.",
    "accountInactive": "Your account is inactive. Please contact your administrator.",
    "sessionExpired": "Your session has expired. Please sign in again."
  },
  "validation": {
    "required": "This field is required.",
    "emailInvalid": "Please enter a valid email address.",
    "passwordTooShort": "Password must be at least 8 characters.",
    "passwordMismatch": "Passwords do not match."
  },
  "actions": {
    "saveFailed": "Save failed. Please try again.",
    "deleteFailed": "Delete failed. Please try again.",
    "loadFailed": "Failed to load data. Please try again.",
    "exportFailed": "Export failed. Please try again.",
    "importFailed": "Import failed. Please try again.",
    "uploadFailed": "Upload failed. Please try again.",
    "copyFailed": "Could not copy to clipboard.",
    "resetFailed": "Reset failed. Please try again.",
    "approveFailed": "Approve failed. Please try again.",
    "rejectFailed": "Reject failed. Please try again."
  }
}
